import React from 'react';
import '../../pages/dashboardtablepage/DashboardTablePage.css'
import Sidebar from '../../components/sidebar/Sidebar';
import DashboardHomePage from "../../components/dashboardhomepage/DashboardHomePage";

const DashboardHome = () => {
    const isMobile = window.innerWidth < 768;

    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    {!isMobile && (
                        <Sidebar/>
                    )}
                    <DashboardHomePage/>
                </div>
            </div>
        </div>
    );
};

export default DashboardHome;
